import React, {useState, useRef} from 'react';
import {Link} from 'react-router-dom'
import FlashMessages, {FlashMessageData} from '../../components/flashMessages.js';
import sharedPOST from '../../helpers/sharedFetch.js';

// Interface for create account parameters
interface CreateAccountParams {
    agreedWithTerms: boolean;
}

// Interface for component props
interface CreateAccountProps {
    name: string;
    email: string;
    onAccountCreated: () => void;
}

export default function CreateAccount({name, email, onAccountCreated}: CreateAccountProps) {

    const [flashProps, setFlashProps] = useState<FlashMessageData>({});
    
    const agreeWithTermsRef = useRef<HTMLInputElement>(null);

    function handleSubmit(e: React.FormEvent<HTMLFormElement>) {

        e.preventDefault();

        setFlashProps({})

        const params: CreateAccountParams = {
            agreedWithTerms: agreeWithTermsRef.current?.checked || false
        }

        sharedPOST(
            '/user/create-account',
            {...params},
            {
                onSuccess: function (response: unknown) {
                    onAccountCreated(); // callback to the parent
                },
                onError: function (error: string) {
                    setFlashProps({error: error});
                }
            }
        )
    }

	return (<>
        <h2 className="text-center mb-3">
            <i className="mdi mdi-account-plus"></i>Create Account
        </h2>
        <form action="/user/create-account" onSubmit={handleSubmit}>
            <div className="form-group">
                <FlashMessages props={flashProps} />
            </div>
            <div className="form-group">
                <label htmlFor="name">Name</label>
                <input
                    type="name"
                    id="name"
                    name="name"
                    className="form-control"
                    placeholder="Enter Name"
                    value={name}
                    disabled
                />
            </div>
            <div className="form-group">
                <label htmlFor="email">Email</label>
                <input
                    type="email"
                    id="email"
                    name="email"
                    className="form-control"
                    placeholder="Enter Email"
                    value={email}
                    disabled
                />
            </div>
            <div className="form-group">
                <input type="checkbox" ref={agreeWithTermsRef} id="agreedWithTerms" name="agreedWithTerms"/>
                {' '}
                <label htmlFor="agreeWithTerms"> 
                    I agree with{' '}  
                    <Link
                        to ="/terms"  
                        style={{textDecoration: 'underline'}} 
                        target={"_blank"}
                    > 
                        {' '}Terms and Conditions
                    </Link>
                </label>
                <br/>
            </div>
            <button type="submit" className="btn btn-primary btn-block">
                Create Account
            </button>
        </form>
    </>)
}
